<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div v-if="lableindex!==3">
      <div v-if="list.length>0">
        <div class="nav" v-for="(item,index) in list" :key="index">
          <div class="navfirst">
            <div class="navfirst-title-box">
              <span class="navfirst-type1" v-if="item.learnstaus==0">进行中</span>
              <span class="navfirst-type2" v-else>结束</span>
              <span class="navfirst-title">{{item.title}}</span>
            </div>
            <div v-if="!item.exampass">
              <div
                v-if="item.learnstaus==0"
                class="color-blue"
              >学习进度：{{item.percentage ? item.percentage:0}}%</div>
              <div v-else class="color-gray">学习进度：已截止</div>
            </div>
            <div v-else-if="item.exampass" class="color-green">
              学习进度：
              <span class="color-green">考试已通过</span>
            </div>
          </div>
          <div class="navsecond">
            <div style="width:850px">
              <el-progress
                :percentage="item.percentage ? item.percentage:0"
                :show-text="false"
                :stroke-width="10"
              ></el-progress>
            </div>
          </div>
          <div class="navthirt">
            <!-- <span class="banji">2021行政培训班</span> -->
            <div class="navthirt-box">
              <div style="margin-right: 20px;">截止学习时间：{{item.learntime}}</div>
              <div style="margin-right: 20px;">考试及格线： {{item.learnscore}}分</div>
              <div>剩余考试次数：{{item.examcount ?item.examcount:0}}次</div>
            </div>
            <div v-if="item.typejuge==1">
              <el-button
                type="primary"
                size="mini"
                @click="testNow(item)"
              >{{item.percentage==100?'重新学习':'开始学习'}}</el-button>

              <!-- exampass考试是否合格  item.examcount考试次数 item.percentage-->

              <!-- :disabled="item.learnstaus!==0 || !item.examcount ||item.percentage<50 ||item.exampass" -->

              <el-button
                type="primary"
                :disabled="item.learnstaus!==0 || !item.examcount ||item.percentage<50 ||item.exampass"
                size="mini"
                @click.stop="gosimulationExamPerson(item)"
              >开始考试</el-button>

              <el-button
                type="primary"
                v-if="item.exampass"
                @click="selectPaper(item)"
                size="mini"
              >查看考卷</el-button>
            </div>
            <div v-else-if="item.typejuge==2">
              <el-button
                type="primary"
                :disabled="item.learnstaus!==0 || !item.examcount ||item.exampass"
                size="mini"
                @click.stop="gosimulationExamPerson(item)"
              >开始考试</el-button>
              <el-button
                type="primary"
                v-if="item.exampass"
                @click="selectPaper(item)"
                size="mini"
              >查看考卷</el-button>
            </div>
            <div v-else-if="item.typejuge==3">
              <el-button
                type="primary"
                size="mini"
                @click="testNow(item)"
              >{{item.percentage==100?'重新学习':'开始学习'}}</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="margin-top:120px">
        <nodata></nodata>
      </div>
      <div class="pagination">
        <el-pagination
          background
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page"
          :page-sizes="[8, 18, 28, 38]"
          :page-size="listQuery.limit"
          layout="total,sizes, prev, pager, next"
          :total="dataCount"
          v-if="dataCount>0"
        ></el-pagination>
      </div>
    </div>
    <div v-else class="xuexijl">
      <div style="height:880px;overflow-y: auto;" v-if="listjl.length !=0">
        <div class="note" v-for="(item,index) in listjl" :key="index">
          <div class="noteheader">
            <div style="font-weight:700;font-size:18px">{{item.docname}}</div>
            <div style="border-radius: 10px;background-color: #f2f2f2;padding:5px">{{item.timeStr}}</div>
          </div>

          <div class="noteimg">
            <img :src="item.imgurl" style="width:600px;height:270px" alt />
          </div>
          <div class="notefooter">
            <div>{{item.createtime}}</div>
            <div style="margin-top:10px">
              <el-button size="small" type="primary" plain @click="playVideoPage(item)">播放</el-button>
              <el-button size="small" type="danger" @click="DeleteNoteRecordel(item)" plain>删除</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="margin-top:120px">
        <nodata></nodata>
      </div>

      <div class="pagination">
        <el-pagination
          background
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChangejl"
          @current-change="handleCurrentChangejl"
          :current-page.sync="listQueryjl.page"
          :page-sizes="[2, 4, 10]"
          :page-size="listQueryjl.limit"
          layout="total,sizes, prev, pager, next"
          :total="dataCountjl"
          v-if="dataCountjl>0"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      width="800px"
      class="dialog-mini"
      v-el-drag-dialog
      title="准入测试内容"
      :visible.sync="innerVisible"
      append-to-body
    >
      <TestContent v-if="innerVisible" :trainId="trainId"></TestContent>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="mini" @click="innerVisible = false">返回</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="830px"
      class="dialog-mini"
      v-el-drag-dialog
      title="准入测试内容"
      :visible.sync="innerVisibleVideo"
      append-to-body
      v-if="innerVisibleVideo"
    >
      <div style="width:800px;height:540px">
        <video-player
          v-if="innerVisibleVideo"
          :class="['vjs-custom-skin']"
          style="object-fit: cover"
          ref="videoPlayer"
          :fluid="true"
          :options="playerOptions"
          :playsinline="false"
          :fullSreen="true"
        ></video-player>
        <!-- @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
        @timeupdate="onPlayerTimeupdate($event)"-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as ApiPerson from '@/api/personcenter/index';
import TestContent from '../../train/trainclass/compoents/testContent.vue';
import elDragDialog from '@/directive/el-dragDialog';

import Vue from 'vue';
import VideoPlayer from 'vue-video-player';
window.videojs = VideoPlayer.videojs;
require('video.js/dist/lang/zh-CN.js');
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import 'videojs-flash'; //引入才能播放rtmp视屏
import 'videojs-contrib-hls'; //引入才能播放m3u8文件
Vue.use(VideoPlayer);

export default {
  components: {
    TestContent,
  },
  directives: {
    elDragDialog,
  },
  data() {
    return {
      innerVisibleVideo: false,
      playerOptions: {
        objectFit: 'contain',
        height: '540px',
        size: '100%',
        autoplay: false,
        muted: false,
        language: 'en',
        webkitPlaysinline: 'true',
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        sources: [
          {
            src: '',
          },
        ],
        presentTiem: '',
        videoStepId: '',
        trainId: this.$route.query.trainId ? this.$route.query.trainId : 0,
      },
      dataCount: 0,
      percentage: 20,
      labledata: ['全部', '进行中', '已结束', '学习笔记'],
      currentPage2: 1,
      lableindex: 0,
      timedata: '2020-06-23 12:03:45',
      learingarea: '上次学到：1.1 地方政府的界定',
      listQuery: {
        page: 1,
        limit: 8,
        userId: this.$store.state.User.ids,
        type: 0,
      },
      listQueryjl: {
        page: 1,
        limit: 2,
        userId: this.$store.state.User.ids,
      },
      list: [],
      newData: '',
      trainId: null,
      innerVisible: false,
      listjl: [],
      dataCountjl: [],
      dataCountjl: 0,
    };
  },
  created() {
    this.myLearnInfoList();
  },
  methods: {
    //查看考卷
    selectPaper(item) {
      localStorage.setItem('trainId', item.id);
      this.$router.push({
        path: '/subMulationExamPerson',
        query: {
          trainId: item.id,
          trainName: item.title,
          learnscore: item.learnscore,
          status: true,
        },
      });
    },
    //立即考试
    gosimulationExamPerson(item) {
      localStorage.setItem('trainId', item.id);
      this.$router.push({
        path: '/simulationExamPerson',
        query: {
          trainId: item.id,
          trainName: item.title,
          learnscore: item.learnscore,
        },
      });
    },
    //立即测试
    testNow(item) {
      this.trainId = item.id;
      localStorage.setItem('trainId', item.id);
      this.$router.push({
        path: '/personCenter/videoleam',
        query: {
          trainid: item.id,
          trainName: item.title,
          learnscore: item.learnscore,
          learnstaus: item.learnstaus,
          typejuge: item.typejuge,
        },
      });
      // this.innerVisible = true;
      // this.$router.push(
      //   '/personCenter/videoleam?id=' + item.learnscore + '&trainid=' + item.id
      // );
    },
    newsVideo(row) {
      if (row.learnStatus == 2) {
        return false;
      }
      if (row.objType == 2) {
        sessionStorage.setItem('trainId', row.trainId);
        this.$router.push({
          path: '/studyclassDetail',
          query: {
            id: row.objId,
            trainId: row.trainId,
          },
        });
      } else if (row.objType == 1) {
        sessionStorage.setItem('trainId', row.trainId);
        this.$router.push({
          path: '/sourceslist/videoLearn',
          query: {
            id: row.objId,
            trainId: row.trainId,
          },
        });
      }
    },
    // 跳转播放页面
    playVideoPage(item) {
      this.innerVisibleVideo = true;
      this.$nextTick(() => {
        this.playerOptions.sources[0].src = item.filepath;
        this.$refs['videoPlayer'].options.autoplay = true;
        this.$refs['videoPlayer'].player.play();
      });
    },

    // 获取学习记录
    GetNoteRecordList() {
      ApiPerson.GetNoteRecord(this.listQueryjl).then((res) => {
        this.listjl = res.data;
        this.dataCountjl = res.count;
      });
    },
    // 删除学习记录
    DeleteNoteRecordel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let data = { id: row.id };
        ApiPerson.DeleteNoteRecord(data).then((res) => {
          this.$message.success('成功');
          this.GetNoteRecordList();
        });
      });
    },
    myLearnInfoList() {
      ApiPerson.myLearnInfoList(this.listQuery).then((res) => {
        this.list = res.data;
        this.dataCount = res.count;
      });
    },
    lableArea(index, item) {
      this.lableindex = index;

      if (index == 3) {
        this.listQueryjl.page = 1;
        this.GetNoteRecordList();
      } else {
        this.listQuery.page = 1;
        if (index == 0) {
          this.listQuery.type = 0;
        } else {
          this.listQuery.type = index;
        }
        this.myLearnInfoList();
      }
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.myLearnInfoList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.myLearnInfoList();
    },
    handleSizeChangejl(val) {
      this.listQueryjl.limit = val;
      this.GetNoteRecordList();
    },
    handleCurrentChangejl(val) {
      this.listQueryjl.page = val;
      this.GetNoteRecordList();
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  height: 1000px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.nav {
  /* width: 830px; */
  height: 100px;
  margin: 0 auto;
  margin: 0 10px;
  margin-top: 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.nav:hover {
  box-shadow: 2px 2px 5px rgba(52, 194, 250, 0.969) !important;
  cursor: pointer;
}
.navfirst {
  display: flex;
  justify-content: space-between;
}
.navfirst-title-box {
  display: flex;
  align-items: center;
}
.navfirst-type1 {
  /* border: 1px solid #03B615; */
  color: #ffffff;
  background-color: #03b615;
  border-radius: 5px;
  height: 22px;
  width: 60px;
  margin-right: 10px;
  text-align: center;
  font-size: 13px;
  line-height: 22px;
}
.navfirst-type2 {
  /* border: 1px solid #EC808D; */
  color: #ffffff;
  background-color: #ec808d;
  border-radius: 5px;
  height: 22px;
  width: 60px;
  margin-right: 10px;
  text-align: center;
}
.color-blue {
  color: #009eee;
}
.color-green {
  color: #03b615;
}
.color-gray {
  color: #a9a9a9;
}
.navfirst-title {
  font-size: 16px;
  font-weight: bold;
}
.navsecond {
  display: flex;
}
.navsecond /deep/.el-progress-bar__inner {
  background: linear-gradient(
    to right,
    rgb(0, 168, 247),
    rgb(119, 227, 241)
  ) !important;
}
.navsecond2 {
  display: flex;
}
.navsecond2 /deep/.el-progress-bar__inner {
  background: #aaaaaa !important;
}
.navthirt {
  display: flex;
  justify-content: space-between;
  color: #343434;
  font-size: 12px;
}

.navthirt-box {
  display: flex;
  color: #9a9a9a;
  font-size: 14px;
}
.banji {
  min-width: 140px;
}
.pagination {
  margin-top: 10px;
  /* text-align: center; */
  padding-left: 10px;
}
.note {
  border-bottom: solid 1px #f2f2f2;
  margin: 0px 20px;
  padding: 20px 20px 10px 20px;
}
.noteheader {
  display: flex;
  justify-content: space-between;
}
.notecontents {
  text-indent: 2em;
  margin-top: 10px;
}
.noteimg {
  margin-top: 20px;
  text-align: center;
}
.notefooter {
  font-size: 16px;
  text-align: right;
  margin-top: 20px;
  color: #7f7f7f;
}
.xuexijl {
  margin-top: 20px;
}
</style>
<style lang="scss">
.dialog-mini {
  .el-dialog__header {
    height: 35px;
    line-height: 35px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    background-color: #f8f8f8;
    padding: 0 20px;
    .el-dialog__title {
      line-height: 34px;
      font-size: 14px;
      color: #333;
    }
    .el-dialog__headerbtn {
      color: #333;
      top: 11.5px;
      right: 11.5px;
    }
  }
  .el-dialog__footer {
    height: 50px;
    width: 100%;
    text-align: center;
    padding: 0px 10px;
    border-top: 1px solid #eee;
    border-radius: 0 0 4px 4px;
    background-color: #f8f8f8;
    line-height: 50px;
  }
  .el-dialog__body {
    padding: 10px;
    .el-form {
      padding-right: 20px;
      padding-top: 10px;
    }
  }
  .el-form-item__label {
    font-size: 12px;
    font-weight: normal !important;
  }
  .el-form-item.el-form-item--small {
    margin-bottom: 8px;
  }
  .el-form-item.is-error.is-required.el-form-item--small {
    margin-bottom: 18px;
  }
}
</style>